function DDUMainSession({value}) {
    const sessionName = {
        0: "Practice",
        1: "Qualify",
        2: "Race",
        3: "HotLap",
        4: "Time Attack",
        5: "Drift",
        6: "Drag",
        7: "Hot Stint",
        8: "Hot Stint SuperPole"
    }[value["session-type"]] || "Uknown";

    return (
        <div className="flex flex-col items-center justify-center w-[33%] max-h-[100%]">
            <h2 className="flex items-center font-bold text-[25px] mt-[-5px]">1<span className="text-[#4b4a4a] text-[20px]">/0</span></h2>
            <p className="uppercase text-[#4b4a4a] font-bold text-[11px] mt-[-5px]">{sessionName}</p>
        </div>
    );
}

export default DDUMainSession;